import React, { useEffect } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import PaymentsAppLayout from "../../Components/Molecules/PaymentsAppLayout";
import PrivateComponentLoadingPage from "../LoadingPage/PrivateComponentLoadingPage";
import { usePayoutStore } from "../../Store/Payout";
import { useParams } from "react-router-dom";
import { PaymentRoutes } from "../../Contracts/Routes";

const PayoutTroubleshootPage: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { payoutTroubleshoot, getPayoutTroubleshoot } = usePayoutStore();

  const { payout_id } = useParams();

  useEffect(() => {
    if (payout_id) {
      getPayoutTroubleshoot(getAccessTokenSilently, payout_id);
    } else {
      throw new Error("Payout ID not found");
    }
  }, [getPayoutTroubleshoot, getAccessTokenSilently, payout_id]);

  return (
    <PaymentsAppLayout documentTitle="Payouts Troubleshoot">
      <a
        className="border border-gray-300 rounded px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-white-smoke"
        href={PaymentRoutes.PAYOUTS}
      >
        Back To Payouts
      </a>
      <div className="flex flex-col space-y-2 my-4">
        <p>
          This page checks if the data that Zomentum Payments pushed to your Quickbooks Online
          account is valid.
        </p>
        <p>If anything is incorrect, we are unable to create the deposit in your account.</p>
        <ul className="list-disc list-inside">
          {payoutTroubleshoot?.errors.map((error, index) => (
            <li key={index} className="text-red-600">
              {error}
            </li>
          ))}
          {payoutTroubleshoot?.confirmations.map((confirmation, index) => (
            <li key={index}>{confirmation}</li>
          ))}
        </ul>
        <p>
          If you have any questions, please{" "}
          <a
            href="mailto:support@zomentum.com?subject=Payout deposit troubleshooting"
            className="text-blue-600"
          >
            contact support
          </a>
          .
        </p>
      </div>
    </PaymentsAppLayout>
  );
};

export default withAuthenticationRequired(PayoutTroubleshootPage, {
  onRedirecting: () => <PrivateComponentLoadingPage />
});
